import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const OrderPengirimanPage = lazy(() => import('./pages/order-pengiriman'))
const DetailOrderPengirimanPage = lazy(() => import('./pages/detail-order-pengiriman'))
const PickingFgOperatorPage = lazy(() => import('./pages/picking-fg-operator'))
const ReturnToStockFgPage = lazy(() => import('./pages/return-to-stock-fg'))

/** Cluster C09 Outbound FG — OFG-01 (order-pengiriman, :id = OFG-01A), OFG-04 (picking-fg-operator), OFG-06 (return-to-stock-fg). */
const outboundFgRoutes: RouteObject[] = [
  {
    path: 'outbound-fg',
    children: [
      {
        path: 'order-pengiriman',
        children: [
          { index: true, element: <OrderPengirimanPage /> },
          { path: ':id', element: <DetailOrderPengirimanPage /> }
        ]
      },
      { path: 'picking-fg-operator', element: <PickingFgOperatorPage /> },
      { path: 'return-to-stock-fg', element: <ReturnToStockFgPage /> }
    ]
  }
]

export default outboundFgRoutes
